/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const InventoryNavigationIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, d: "M17 9c-1.655 0-3-1.345-3-3s1.345-3 3-3 3 1.345 3 3-1.345 3-3 3zm0-4.5a1.501 1.501 0 000 3 1.501 1.501 0 000-3z" }),
        React.createElement("path", { fill: "currentColor", d: "M20.25 10a0.74 0.74 0 01-0.53-0.22l-1.5-1.5a0.75 0.75 0 011.06-1.06l1.5 1.5A0.75 0.75 0 0120.25 10zm-7.75 0H4.75A1.752 1.752 0 013 8.25v-3.5A1.752 1.752 0 014.75 3h7.5a0.749 0.749 0 110 1.5h-7.5A0.25 0.25 0 004.5 4.75v3.5A0.25 0.25 0 004.75 8.5h7.75a0.749 0.749 0 110 1.5zm5.75 10.75H6.75a0.749 0.749 0 110-1.5h11.5a0.749 0.749 0 110 1.5zM4 21a1 1 0 100-2 1 1 0 000 2zm14.25-3.25H6.75a0.749 0.749 0 110-1.5h11.5a0.749 0.749 0 110 1.5zM4 18a1 1 0 100-2 1 1 0 000 2zm14.25-3.25H6.75a0.749 0.749 0 110-1.5h11.5a0.749 0.749 0 110 1.5zM4 15a1 1 0 100-2 1 1 0 000 2z" })));
};
//# sourceMappingURL=InventoryNavigationIcon.js.map